@if (cardInfo(); as info) {
  <div class="communication-activity-wrapper">
    <crm-activity-card [activity]="activitySignal()" [showTitle]="isCampaignSMS() || isInbox()" [icon]="activityIcon()">
      <!-- Activity title -->
      <span activity-title>
        @if (isCampaignSMS()) {
          {{ headerText() }}
        }
        @if (isInbox()) {
          {{ 'CONTACT.ACTIVITIES.HEADER_ADDITIONAL_TEXT.CONVERSATION.CREATED' | translate }}
        }
      </span>

      <!-- Activity preview -->
      <div activity-preview>
        @if (info.activityUrl && !isCampaignSMS()) {
          <div class="link">
            <a [href]="info.activityUrl">{{ info.activityUrlName || info.activityUrl }}</a>
          </div>
        }

        @if (info.body && !isCampaignSMS()) {
          <crm-collapsible-section [maxHeightPx]="100">
            <div [innerHtml]="info.body | sanitizeHtml"></div>
          </crm-collapsible-section>
        }

        @if (isCampaignSMS()) {
          <div class="campaign-display">
            {{ info.activityName }}
            @if (info.sourceName) {
              {{ 'CONTACT.ACTIVITIES.CREATED_FROM' | translate }}
              <strong>
                <span class="campaign-display">
                  <a [href]="info.activityUrl">{{ info.sourceName }}</a>
                </span>
              </strong>
            }
          </div>
        }
      </div>
    </crm-activity-card>
  </div>
}
